<div *ngIf="permissionObj['EXT_COM_SubmissionDetailsRequestedReviewDate_Visible']">
  <span
    ><img
      *ngIf="!isDateSelected && !isDisabled"
      class="margin-right-xxs"
      src="\assets\images\draftIcon.svg"
  /></span>
  <span>Requested review date</span>
  <form [formGroup]="dateForm">
    <div
      #datepicker
      class="datePicker font-size-12 margin-top-xxs"
      *ngIf="permissionObj['EXT_COM_SubmissionDetailsRequestedReviewDate_Enable']"
    >
      <dds-datepicker
        id="requestedReviewDate-datepicker"
        [ngClass]="{ 'cursor-clickable': !isDisabled }"
        [size]="htmlElementSize"
        [placeholder]="datePickerOptions.placeholder ?? ''"
        [format]="datePickerOptions.format ?? ''"
        [minMode]="datePickerOptions.minMode ?? ''"
        [disabledDates]="datePickerOptions.disabledDates ?? {}"
        [isResponsive]="datePickerOptions.isResponsive ?? false"
        [isManualInput]="datePickerOptions.isManualInput ?? false"
        [readonly]="isDisabled"
        formControlName="selectedDateCtrl"
        [stickerPosition]="datePickerOptions.stickerPosition ?? ''"
        (onHidden)="datepickerOpened = false"
        (onShown)="datepickerOpened = true"
        (click)="openDatepicker()"
      >
      </dds-datepicker>
    </div>
  </form>
  <ng-container *ngIf="!permissionObj['EXT_COM_SubmissionDetailsRequestedReviewDate_Enable']">
    {{
      dateForm.get("selectedDateCtrl")?.value | date : dateFormaterUS
    }}</ng-container
  >
  <span class="datePickerMsg">in {{ businessDays }} business day(s)</span>
</div>
